import styled, { keyframes } from 'styled-components';
import fn from '../../helpers/fn';

const fadein = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export default fn(__filename, styled.div`
  opacity: 0;
  animation: ${fadein} 500ms ease forwards;
`);



// WEBPACK FOOTER //
// ./src/components/blocks/FadeIn.js